import React, { useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';
import IfysEnquiryForm from '../../components/IfysEnquiryForm';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Contact', to: '/contact/contact-ifys' },
  { label: 'Contact IFYS' },
];

const ContactIfysPage = () => {
  const address = '37 Dalton Dr, Maroochydore QLD 4558';
  const mapSrc = useMemo(() => {
    const q = encodeURIComponent(address);
    return `https://www.google.com/maps?q=${q}&output=embed`;
  }, []);

  return (
    <PageLayout activeLink="contact">
      <PageHero
        title="Contact IFYS"
        backgroundImage="/images/service-headers/contact%201.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6 tracking-tight">
            How can we help?
          </h2>
          <div className="space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed">
            <p>Please do not hesitate to contact us if you have any questions or worries.</p>
            <p>
              Our team is committed to offering professional help and eagerly anticipates hearing from you. In addition
              to your questions, if you would like to provide compliments, feedback or complaints you can do so via the
              enquiry form below, or email{' '}
              <a href="mailto:admin@ifys.com.au?subject=Feedback" className="text-ifys-blue font-semibold hover:underline">
                admin@ifys.com.au
              </a>. You can read our{' '}
              <a
                href="/documents/POL-ORG-Complaints%20Feedback%20and%20Appeals.pdf"
                target="_blank"
                rel="noreferrer"
                className="text-ifys-blue font-semibold hover:underline"
              >
                Complaints Feedback and Appeals Policy
              </a>
              {' '}for details.
            </p>
            <p className="text-gray-700">
              Reception: <span className="font-semibold">07 5438 3000</span> | Fax: 07 5437 6793 |{' '}
              <a href="mailto:admin@ifys.com.au" className="text-ifys-blue hover:underline">admin@ifys.com.au</a>
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 md:py-14">
          <div className="rounded-2xl overflow-hidden bg-white shadow-sm border border-gray-200">
            <iframe
              title={`Map: ${address}`}
              src={mapSrc}
              className="w-full h-[420px] md:h-[520px] border-0 block"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      <section className="relative bg-ifys-light-gray overflow-hidden border-t border-gray-200">
        <img
          src="/images/image.png"
          alt=""
          aria-hidden
          loading="lazy"
          className="hidden lg:block absolute -top-36 -right-36 w-80 h-80 object-cover rounded-full pointer-events-none"
        />
        <img
          src="/images/image.png"
          alt=""
          aria-hidden
          loading="lazy"
          className="hidden lg:block absolute -bottom-48 -left-48 w-96 h-96 object-cover rounded-full pointer-events-none"
        />

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 relative z-10">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-8 md:p-10">
            <div className="mb-6 sm:mb-8 text-center">
              <h2 className="text-2xl sm:text-3xl font-bold text-ifys-blue tracking-tight">
                Send us an enquiry
              </h2>
              <p className="mt-2 text-sm sm:text-base text-gray-600">
                We&rsquo;ll get back to you as soon as we can.
              </p>
            </div>
            <IfysEnquiryForm formId="contact" />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default ContactIfysPage;
